import React from 'react';
import { Link } from 'react-router-dom';
import {
  FooterWrapper,
  FooterContent,
  FooterSection,
  FooterTitle,
  FooterText,
  FooterLink,
  Copyright
} from './styles';
import styled from 'styled-components';
import { FaEnvelope } from 'react-icons/fa';

const FooterColumn = styled.div`
  min-width: 200px;
`;

const FooterLinkContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

const FooterIcon = styled.div`
  margin-right: 5px;
  display: flex;
  align-items: center;
`;

const Footer = () => {
  return (
    <FooterWrapper>
      <FooterContent>
        <FooterColumn>
          <FooterTitle>About Core Plasma</FooterTitle>
          <FooterText>
            Leading the way in plasma technology innovation.
          </FooterText>
        </FooterColumn>
        <FooterColumn>
          <FooterTitle>Contact</FooterTitle>
          <FooterLinkContainer>
            <FooterIcon><FaEnvelope /></FooterIcon>
            <FooterLink href="mailto:contact@coreplasma.com">contact@coreplasma.com</FooterLink>
          </FooterLinkContainer>
        </FooterColumn>
        <FooterColumn>
          <FooterTitle>Quick Links</FooterTitle>
          <FooterLink as={Link} to="/">Home</FooterLink>
          <FooterLink as={Link} to="/about">About</FooterLink>
          <FooterLink as={Link} to="/patents">Patents</FooterLink>
          <FooterLink as={Link} to="/contact">Contact</FooterLink>
        </FooterColumn>
      </FooterContent>

      <Copyright>
        © {new Date().getFullYear()} Core Plasma. All rights reserved.
      </Copyright>
    </FooterWrapper>
  );
};

export default Footer; 